<template>
	<ul class="cbs-circle-steps flex">
		<li
            v-for="(item, index) in value" :key="index"
			:class="[
				'item cbs-circle-steps__item font-bold inline-block text-center rounded-full h-10 w-10 sm:h-12 sm:w-12 flex items-center justify-center',
				{
                    'text-white cursor-pointer': item.isEnable,
					'opacity-50': !item.isActive,
                    'item--active bg-solid-primary': item.isActive,
                    'bg-solid-green-2': item.isEnable && !item.isActive,
					'item--disabled bg-gray-5 cursor-not-allowed': !item.isEnable
				}
			]"
            @click="item.isEnable && !item.isActive && $emit('onClickStep', item, index)"
		>
			<span>{{ item.text }}</span>
		</li>
	</ul>
</template>

<script>
export default {
	name: "CbsCircleSteps",
	props: {
		value: {
			type: Array,
			validator: prop =>
				prop.every(
					objData =>
						objData.hasOwnProperty("id") &&
						objData.hasOwnProperty("text") &&
						objData.hasOwnProperty("isActive") &&
						objData.hasOwnProperty("isEnable")
				)
		}
    },
    emits: {
        onClickStep: {}
    }
};
</script>

<style lang="scss" scoped>
.cbs-circle-steps {
    .item {
        position: relative;
        margin: 0 1rem;
        z-index: 1;

        &:not(:first-child) {
             &::before {
                content: '';
                position: absolute;
                top: 1.5rem;
                left: -2rem;
                width: 28px;
                height: 2px;
                z-index: -1;
                background-color: var(--color-solid-green-2) !important;

                @media screen and (max-width: 576px) {
                    top: 1.2rem;
                }
            }

            &.item--disabled {
                &::before {
                    background-color: var(--color-gray-4) !important;
                }
            }
        }
    }
}
</style>>
